export const seperatorTheme = {
  color: '--medkit-seperator-color',
}
